export const SESSION_CONTAINER_HEIGHT = 420;
export const SESSION_CONTAINER_HEIGHT_PREVIEW = 300;

export const WEB_CLIP_MAX_WIDTH_SIZE_PX = 360;
export const WEB_CLIP_MAX_HEIGHT_SIZE_PX = 300;

export enum SessionViewMode {
  /**
   * The default state of the chrome extension when it has not yet been interacted with
   * or collapsed and processes things on the background.
   */
  Minimized = "minimized",
  /**
   * When the extension is open, after the initial clipping process has been completed.
   */
  Standard = "standard",
  /**
   * We show the user a notification once a session has completed processing.
   */
  Notification = "notification",
  /**
   * Shows only the first webclip event, used for preview display mode.
   */
  Preview = "preview",
}
